import { inject, Injectable } from "@angular/core";
import { USER_GATEWAY } from "@app/app.providers";
import { OutputSaveManyType } from "@arch/domain/gateway";

@Injectable({
    providedIn: "root"
})
export class UpdateUserController {
    private readonly userGateway = inject(USER_GATEWAY);
    constructor() {}

    public async execute(input: Input): Promise<OutputSaveManyType> {
        const response = await this.userGateway.saveMany({
            accountingId: input.accountingId,
            users: [
                {
                    _id: input._id,
                    name: input.username,
                    email: input.email,
                    ...(input.whatsapp && {
                        whatsapp: input.whatsapp
                    })
                }
            ]
        });
        return response;
    }
}

type Input = {
    accountingId: string;
    _id: string;
    username: string;
    email: string;
    whatsapp?: string;
};
